import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonLHCOmponentStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from './device-aware-component';
import { DepInjMixin } from '@APP/mixins/dependency';
import { classMap } from 'lit/directives/class-map';
type OwnDeps = {};

@customElement('lh-header')
export class LHHeader extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      css`
        ${commonLHCOmponentStyle},
        ${css`
          :host-context([display-mode="summary"]) #background-mask {
            border-radius: 0;
      }
        :host {
          --own-height: var(--header-height, 14rem);
          --corner: 20px;
          z-index: 3;
          position: relative;
          display: block;
          width: 100%;
          height: var(--own-height);
          color: var(--c-emphasize-pri);
          transition: var(--transition-speed, 350ms) var(--transition-switch);
          filter: drop-shadow( 0px 17px 41px rgba(25, 72, 146, 0.1));
        }
        :host(.hidebg){
          --own-height: unset;
        }
        :host(.look-like-regular-section){
          height: unset;
        }
        #background-mask {
          z-index: -1;
          position: absolute;
          background: var(--c-background-mask);
          top: 0;
          left: 0;
          width: 100%;
          height: var(--own-height);
          transition: var(--transition-speed, 350ms) var(--transition-switch);
          border-radius: 0 0 4.5rem 0;
          overflow: hidden;
        }

        #background-mask svg {
          position: absolute;
          width: 103%;
          height: 110%;
          bottom: -4rem;
          left: 0;
        }

        #title {
          position: absolute;
          display: inline-block;
          top: 1rem;
          width: 100%;
          text-align: center;
          direction: ltr;
        }

        #wrapper {
          overflow: hidden;
          height: 100%;
        }

        #wrapper.look-like-regular-section {
          margin-block-start: -2.5rem;
          height: 10rem;
          display: flex;
          align-items: center;
        }

        slot {
          z-index: 0;
        }
      `},
    `,
    ];
  };
  static get desktopStyles() {
    return [
      css`
      #background-mask {
        z-index: -1;
        position: absolute;
      background: var(--c-background-mask);
      top: 0;
      left: 0;
      width: 100%;
      height: var(--own-height);
      transition: var(--transition-speed, 350ms) var(--transition-switch);
      border-radius: 0 0 0 4.5rem;
      overflow: hidden;
    }
    .chat-icon {
      margin-left: 6rem;
      display: none;
      margin-top: 9rem;
    }
    .text{
      position: absolute;
      bottom: 28px;
      margin-left: 12rem;
      font-weight: normal;
      font-size: 1.8rem;
      color: var(--c-text-menu);
    }
    `,
    ];
  };
  static get mobileStyles() {
    return [css`

    `];
  };
  static get ltrStyles() {
    return [
      css`
        #background-mask {
          border-radius: 0 0 4.5rem 0;
        }
      `,
    ];
  };
  renderContent() {
    const isDesktop = this.userDevice === 'desktop';
    const wrapperClasses = {
      'look-like-regular-section': [...this.classList].includes('look-like-regular-section'),
    };
    return html`
      <div id="wrapper" class=${classMap(wrapperClasses)}>
      ${isDesktop ? html`<div id="background-mask"></div> ` : ''}
        <slot></slot>
      </div>
    `;
  }
}
